module.exports = __webpack_public_path__ + "fonts/3e1f7a5.eot";